import React, { useContext, useEffect, useState } from 'react';
import { enrichAEMProductsWithOutSystemData, mapAEMProductToCardData } from '../ProductCard/ProductCard.helper';
import { ProductCard } from '../ProductCard/ProductCard';
import { ProductCardSlider } from '../ProductCard/ProductCardsSlider';
import { ProductContext } from '../../../pages/ProductStencil';
import { CardSliderSkeleton } from "../../../atoms/effects/skeletons/product-stencil/CardSliderSkeleton";
import { useI18N } from "../../../my-puratos/hoc/withI18N";
import { GA4ComponentType } from "../../../../analytics/ga4/types/component";
import { isEcommerceEnabled } from '../../../../selectors/generic';

interface IProduct {
    id: string;
}

export const RELATED_PRODUCTS_KEY = 'relatedProductsCount';
export const RELATED_PRODUCTS_UPDATED_EVENT = 'relatedProductsCountUpdated';


export const RelatedProducts = () => {
    const productData = useContext(ProductContext);
    const [relatedProducts, setRelatedProducts] = useState<any>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const translate = useI18N();

    useEffect(() => {
        const fetchRelatedProducts = async () => {
            try {
                const products = productData.relatedProducts?.products as IProduct[];
                if (products.length) {
                    const updatedProducts = isEcommerceEnabled() ? await enrichAEMProductsWithOutSystemData([...products].splice(0, 12)) : [...products];
                    setRelatedProducts(updatedProducts);
                    sessionStorage.setItem(RELATED_PRODUCTS_KEY, updatedProducts.length.toString());
                    window.dispatchEvent(new Event(RELATED_PRODUCTS_UPDATED_EVENT));
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsDataLoading(false);
            }
        };

        fetchRelatedProducts();
    }, [productData]);

    if (isDataLoading) {
        return (<CardSliderSkeleton/>);
    }

    if (!relatedProducts.length) {
        return null;
    }
    
    const recommendedText = productData.product.recommendedAlternativeVaritionsLabel || 'Recommended alternative products'
    const renditionFallback = productData.product.renditionFallback;
    const renderedProductCards = relatedProducts.map((product, index) => (
        <ProductCard data={mapAEMProductToCardData(product, renditionFallback, GA4ComponentType.PDP_RELATED_PRODUCTS)} key={index} />
    ));

    return (
        <div className="pdp-section__container">
            <ProductCardSlider title={translate(recommendedText)} componentId={"related-products"}>
                {renderedProductCards}
            </ProductCardSlider>
        </div>
    );
};

export default RelatedProducts;